import { render, staticRenderFns } from "./TuokeLeadDialog.vue?vue&type=template&id=5a4a3466&scoped=true"
import script from "./TuokeLeadDialog.vue?vue&type=script&lang=js"
export * from "./TuokeLeadDialog.vue?vue&type=script&lang=js"
import style0 from "./TuokeLeadDialog.vue?vue&type=style&index=0&id=5a4a3466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a3466",
  null
  
)

export default component.exports